@if (headerText) {
  <oph-x-button class="dialog-close" (click)="cancel.emit()" title="Close dialog" />
  <h1 [style.margin-bottom.px]="headerMarginBottom">{{ headerText }}</h1>
}

<div [style.padding]="contentPadding" class="content-container">
  <ng-content></ng-content>
</div>

@if (!hideButtons) {
  <div class="button-container">
    @if (activePanel === ProjectTaskDialogPanels.NewBasicInfo) {
      <oph-button
        appearance="outline"
        color="gray"
        [style]="{color: 'var(--brown-med)', padding: '0 30px', fontWeight: '400'}"
        (click)="cancel.emit()"
        class="left-button"
        >Cancel</oph-button
      >
      <div class="next-buttons-container">
        <oph-button
          appearance="outline"
          color="gray"
          [style]="{color: 'var(--brown-med)', width: '100%', padding: '0 15px', fontWeight: '400'}"
          (click)="skip.emit()"
          class="skip-button"
          [disabled]="!panelIsValid"
          >Skip to Subtasks
          <oph-icon name="chevron-right-double-green"></oph-icon>
        </oph-button>
        <oph-button
          appearance="solid"
          color="green"
          [style]="{width: '100%', padding: '0 30px'}"
          [disabled]="!panelIsValid"
          (click)="next.emit()"
          class="next-button"
        >
          Next
          <img src="assets/img/icons/chevron-right-white.svg" />
        </oph-button>
      </div>
    } @else if (activePanel === ProjectTaskDialogPanels.DateTimePicker) {
      <oph-button
        appearance="outline"
        color="gray"
        [style]="{color: 'var(--brown-med)', padding: '0 30px', fontWeight: '400'}"
        (click)="cancel.emit()"
        class="left-button"
        >Cancel</oph-button
      >
      <oph-button appearance="solid" color="green" [style]="{width: '100%'}" (click)="save.emit()" class="next-button">
        Save
      </oph-button>
    } @else if (activePanel === ProjectTaskDialogPanels.Assignments) {
      <oph-button
        appearance="outline"
        color="gray"
        [style]="{color: 'var(--brown-med)', width: '100%'}"
        (click)="back.emit()"
        class="left-button"
        >Back</oph-button
      >
    } @else {
      <oph-button
        appearance="outline"
        color="gray"
        [style]="{color: 'var(--brown-med)', width: '100%'}"
        (click)="back.emit()"
        class="left-button"
        >Back</oph-button
      >
      <oph-button appearance="text" color="brown" (click)="cancel.emit()" class="desktop">Cancel</oph-button>
      <oph-button
        [disabled]="!panelIsValid"
        appearance="solid"
        color="green"
        [style]="{width: '100%', padding: '0 30px'}"
        (click)="next.emit()"
        class="next-button"
      >
        Next
        <img src="assets/img/icons/chevron-right-white.svg" />
      </oph-button>
    }
  </div>
}
